import React, { Component } from 'react';
import { connect } from 'react-redux';
import store from '../../../store/reducers/rootReducer';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Divider } from '@material-ui/core';

export class SingleProducts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };
  }
  handle = (e, product) => {
    e.preventDefault();
    if (localStorage.getItem('cart')) {
      var setcart = JSON.parse(localStorage.getItem('cart'));
      var container = setcart.filter((item) => item.pid === product.pid);
      if (container.length === 0) {
        setcart[setcart.length] = { ...product, quantity: 1 };
        localStorage.setItem('cart', JSON.stringify(setcart));
        store.dispatch({ type: 'ADD_TO_CART', payload: { data: setcart } });
      }
    } else {
      var addtolocal = [{ ...product, quantity: 1 }];
      localStorage.setItem('cart', JSON.stringify(addtolocal));
      store.dispatch({ type: 'ADD_TO_CART', payload: { data: addtolocal } });
    }
  };

  toggle = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  render() {
    const added = localStorage.getItem('cart')
      ? JSON.parse(localStorage.getItem('cart')).filter(
          (item) => item.pid === this.props.pid
        )
      : [];
    var desc = this.props.description[0];
    var ellipsis = '...';
    var brt = true;
    if (desc.length > 39) {
      brt = false;
    }
    if (desc.length > 61) {
      desc = desc.slice(0, 61);
      desc = desc.concat(ellipsis);
      // brt = true;
    }
    var name = this.props.name;
    var ellipsis2 = '..';
    // var brt2 = true;
    // if (name.length > 16) {
    //   brt2 = false;
    // }
    if (name.length > 20) {
      name = name.slice(0, 20);
      name = name.concat(ellipsis2);
      // brt = true;
    }
    return (
      <div className="col-12 col-md-4 pt-1  pb-1">
        {/* Modal */}
        <Modal isOpen={this.state.isOpen} size="lg" toggle={this.toggle}>
          <ModalHeader toggle={this.toggle}>Product Details</ModalHeader>
          <ModalBody>
            <div className="container-fluid">
              <div className="row">
                <div className="col-6" style={{ maxHeight: '15em' }}>
                  <img
                    src={this.props.image}
                    alt="product details"
                    style={{ width: '200px', height: '200px' }}
                  />
                </div>
                <div className="col-6">
                  <div className="row">
                    <div className="col-12">
                      <h2 style={{ textTransform: 'capitalize' }}>
                        {' '}
                        {this.props.name}{' '}
                      </h2>
                    </div>
                    <div className="col-12">
                      <h4> ${this.props.price} </h4>
                    </div>
                    <div className="col-12" style={{ wordWrap: 'break-word' }}>
                      <h6> {this.props.description} </h6>
                    </div>
                    <div className="col-12">
                      {this.props.stock[0] || this.props.stock > 0 ? (
                        <button
                          className="btn btnAdd"
                          onClick={(event) =>
                            this.handle(event, this.props.product)
                          }
                        >
                          {' '}
                          {added.length === 0 ? (
                            <i className="fa fa-plus"> Add</i>
                          ) : (
                            'Added'
                          )}
                        </button>
                      ) : (
                        <button className="btn btnAdd"> Out of stock</button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>
        {/* Modal end */}

        <div className="container">
          {this.props.product.price[0] < this.props.product.mrp[0] ? (
            <span
              class="badge badge-success"
              style={{ width: '20%', position: 'absolute' }}
            >
              On Sale
            </span>
          ) : null}
          <div className="row display" id="br_6" onClick={this.toggle}>
            <div className="col-4" style={{ padding: '0' }}>
              <img
                src={this.props.image}
                style={{ height: '9em', width: '100%', borderRadius: '5%' }}
                alt="product"
              />
            </div>
            <div className="col-8">
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <h5
                      style={{
                        color: 'rgba(0, 0, 0, 0.82)',
                        fontWeight: 'bold',
                        paddingBottom: '1px',
                        marginBottom: '1px',
                        left: '0px',
                        textAlign: 'left',
                        wordWrap: 'break-word',
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis',
                        textTransform: 'capitalize'
                      }}
                    >
                      {this.props.name}
                    </h5>
                    {/* <p style={{textAlign:'left',wordWrap:'break-word',overflow:'hidden',whiteSpace:'nowrap',textOverflow:'ellipsis', marginBottom:'0'}}>
                              {this.props.product.sub_category}
                            </p> */}
                    <p style={{ textAlign: 'left', wordWrap: 'break-word' }}>
                      {desc}
                    </p>
                    {brt ? <br /> : null}
                  </div>
                </div>
                <Divider />
                <div className="row mt-2 " style={{ marginLeft: 'auto' }}>
                  <div
                    className="col-6"
                    style={{
                      textAlign: 'initial',
                      padding: 'inherit',
                      fontWeight: 'bold'
                    }}
                  >
                    {/* <span className="badge badge-info badge-pill" style={{fontSize:'larger',width:'5.5rem',overflow:'hidden',whiteSpace:'nowrap',textOverflow:'ellipsis'}}>  */}
                    ${this.props.price}
                    {/* </span> */}
                  </div>
                  <div className="col-6" style={{ textAlign: 'right' }}>
                    {this.props.stock[0] || this.props.stock > 0 ? (
                      <button
                        className="btn btnAdd"
                        style={{ padding: '0.2rem 0.75rem' }}
                        onClick={(event) =>
                          this.handle(event, this.props.product)
                        }
                      >
                        {' '}
                        <i className="fa fa-plus">&nbsp;Add</i>
                      </button>
                    ) : (
                      <button className="btn btnAdd"> Out of stock</button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateWithProps = (state) => ({
  vendors: state.user.vendors,
  subCategories: state.user.subCategories,
  products: state.user,
  vendor: state.shared.vendor,
  auth: state.user.auth,
  loader: state.ui.user_loading
});

export default connect(mapStateWithProps, null)(SingleProducts);
